import { baseUrl, requestHeader } from '../../config';
import Axios from 'axios';
import { CatchReturnError } from "./actionHandler";
import { InitialPromoDetail } from '../../views/types/promoCode';
// requestHeader.Authorization = localStorage.getItem('saw-token') || ""
export interface promoCodePayload {
    code: string, percentage: number
}

export const deletePromo = (promoUID: string) => {
    return Axios.delete(baseUrl + '/promoCode/' + promoUID, requestHeader).then(async res => {
        let response = res['data']
        return response
    }).catch(err => {
        CatchReturnError(err)
    })
}
export const generatePromo = (payload: InitialPromoDetail) => {
    return Axios.post(baseUrl + '/generatePromo', payload, requestHeader).then(async res => {
        let response = res['data']
        return response
    }).catch(err => {
        CatchReturnError(err)
    })
}

export const getPromoList = (payload: { page: number, pageLimit: number }) => {
    return Axios.get(baseUrl + `/promoCode?page=${payload.page || 1}&pageLimit=${payload.pageLimit || 10}`, requestHeader).then(async res => {
        let response = res['data']
        return response
    }).catch(err => {
        CatchReturnError(err)
    })
}

export const getPromoDetails = (promoCode: string) => {
    return Axios.get(baseUrl + `/getPromoDetails/${promoCode}`, requestHeader).then(async res => {
        let response = res['data']
        return response
    }).catch(err => {
        CatchReturnError(err)
    })
}

export const getLeadPromoDetails = (promoCode: string, leadUID: string) => {
    return Axios.get(baseUrl + `/getLeadPromoDetails/${promoCode}/${leadUID}`).then(async res => {
        let response = res['data']
        return response
    }).catch(err => {
        CatchReturnError(err)
    })
}